import { TEMPLATE } from "../../constants";
import { BODY_COMPONENT_MAPPING, bodySchema } from "./bodyMapping";
import { FOOTER_COMPONENT_MAPPING, footerSchema } from "./footerMapping";
import { HEADER_COMPONENT_MAPPING, headerSchema } from "./headerMapping";
import { applyScreenStyle } from "../themeUtils";

export const templateSchema = (activeSchema) => {
  return activeSchema?.components
    ?.map((item) => {
      const label = item.label.toLowerCase();
      switch (label) {
        case TEMPLATE.HEADER:
          return headerSchema(item.components, HEADER_COMPONENT_MAPPING);
        case TEMPLATE.BODY: {
          requestAnimationFrame(() => applyScreenStyle(item));
          return bodySchema(item.components, BODY_COMPONENT_MAPPING);
        }
        case TEMPLATE.FOOTER:
          return footerSchema(item.components, FOOTER_COMPONENT_MAPPING);
        default:
          return null;
      }
    })
    .flat()
    .filter(Boolean);
};
